import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import apiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

const baseUrl = "/api/dog/analize/labPosiljka";

// ==================== THUNKS (POST ONLY) ====================

/**
 * Create new lab shipment and assign samples to it
 */
export const createLabPosiljka = createAsyncThunk(
  "labPosiljka/create",
  async (dto, { rejectWithValue }) => {
    try {
      const response = await apiClient.post(baseUrl, dto);
      return response.data?.output;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

// ==================== SLICE ====================

const labPosiljkaSlice = createSlice({
  name: "labPosiljka",
  initialState: {
    current: null,
    isLoading: false,
    error: null,
  },
  reducers: {
    clearCurrent: (state) => {
      state.current = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createLabPosiljka.fulfilled, (state, action) => {
        state.isLoading = false;
        state.current = action.payload;
      })
      .addCase(createLabPosiljka.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createLabPosiljka.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || null;
        state.details = null;
      });
  },
});

export const { clearCurrent } = labPosiljkaSlice.actions;

export default labPosiljkaSlice.reducer;
